import { useState, useEffect } from "react";

/**
 * Detects if WebGL is running in software mode (e.g. when Chrome's
 * "Use graphics acceleration when available" is disabled).
 * Returns true when we should use the lightweight fallback (static image),
 * false when hardware-accelerated 3D (Spline) is safe to use.
 */
const useShouldUseStaticFallback = () => {
  const [useFallback, setUseFallback] = useState(true); // assume fallback until we know

  useEffect(() => {
    if (typeof window === "undefined") return;

    const canvas = document.createElement("canvas");
    let gl = null;

    try {
      gl =
        canvas.getContext("webgl") ||
        canvas.getContext("experimental-webgl");
    } catch (_) {
      setUseFallback(true);
      return;
    }

    if (!gl) {
      setUseFallback(true);
      return;
    }

    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    if (debugInfo) {
      const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || "";
      const isSoftware =
        /SwiftShader|llvmpipe|softpipe|Microsoft Basic Render|Mesa|ANGLE.*Software/i.test(
          renderer
        );
      setUseFallback(isSoftware);
    } else {
      setUseFallback(false); // can't detect, assume hardware
    }
  }, []);

  return useFallback;
};

export default useShouldUseStaticFallback;
